<template>
  <div class="row">
    <component
      :is="itemComponent"
      v-for="(post, index) in posts"
      :key="index"
      :index="index"
      :post="post"
      :is-column-layout="isColumnLayout"
    />
  </div>
</template>

<script setup>
import BasicListItem from 'components/render/BasicListItem.vue';
import FeedListItem from 'components/render/FeedListItem.vue';
import ColumnListItem from 'components/render/ColumnListItem.vue';
import { computed } from 'vue';
import { useRenderStore } from 'stores/render';
import { storeToRefs } from 'pinia';

const renderStore = useRenderStore();
const { settings } = storeToRefs(renderStore);

const props = defineProps({
  posts: {
    type: Array,
    default: () => [],
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
  isColumnLayout: {
    type: Boolean,
    default: false,
  },
});

const itemComponent = computed(() => {
  if (props.isMobile) {
    return BasicListItem;
  }

  return {
    basic: BasicListItem,
    feed: FeedListItem,
    column: ColumnListItem,
  }[settings.value.metaFields.templateLayout];
});
</script>
